import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=2fc04fc4&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"
import style0 from "./payment.vue?vue&type=style&index=0&id=2fc04fc4&prod&lang=scss&scoped=true"
import style1 from "./payment.vue?vue&type=style&index=1&id=2fc04fc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc04fc4",
  null
  
)

export default component.exports